import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Row } from 'reactstrap';
import { without, range } from 'underscore';
import Checkbox from '../field/checkbox';

const OPTIONS = {
  residential: [
    {
      label: 'Any',
      value: ''
    },
    'Bay',
    'Canal',
    'Creek',
    'Fresh Water',
    'Gulf Frontage',
    'Intersecting Canal',
    'Lagoon',
    'Lake',
    'Mangrove',
    'Navigable',
    {
      label: 'No Waterfront',
      value: 'None'
    },
    'On the Gulf Beach',
    'Rip Rap',
    'River Frontage',
    'Seawall'
    // 'See Remarks',
    // 'WaterfrontDesc',
    // 'NULL',
    // 'None'
  ],

  land: [
    {
      label: 'Any',
      value: ''
    },
    'Bay',
    'Basin',
    'Canal',
    'Creek',
    'Fresh Water',
    'Gulf Frontage',
    'Intersecting Canal',
    'Lagoon',
    'Lake',
    'Mangrove',
    'Navigable',
    {
      label: 'No Waterfront',
      value: 'None'
    },
    'On the Gulf Beach',
    'Rip Rap',
    'River Frontage',
    'Seawall'
  ]
};

function RenderCheckbox(props) {
  const { input, meta, ...checkboxProps } = props;
  const checked =
    (input.value && input.value.length === 0 && props.value === '') ||
    (input.value.indexOf && input.value.indexOf(props.value) !== -1);
  return (
    <Checkbox
      {...checkboxProps}
      checked={checked}
      onChange={e => {
        const { checked } = e.target;

        var newValue = [].concat(input.value);

        if (checked && props.value === '') {
          newValue = [];
        } else if (checked && newValue.indexOf(props.value) === -1) {
          newValue.push(props.value);
        } else {
          newValue = without(newValue, props.value);
        }

        if (newValue.indexOf('') !== -1) {
          newValue = without(newValue, '');
        }

        return input.onChange(newValue);
      }}
    />
  );
}

class WaterfrontTypeFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const labelClassName = `${BS.justifyContentStart} ${BS.mb1}`;
    const {
      className,
      numCols,
      numColsSm,
      numInnerCols,
      numInnerColsSm,
      type,
      ...props
    } = this.props;
    const options = OPTIONS[type];
    const colSize = Math.ceil(12 / numCols);
    const colSizeSm = Math.ceil(12 / numColsSm);
    const colInnerSize = Math.ceil(12 / numInnerCols);
    const colInnerSizeSm = Math.ceil(12 / numInnerColsSm);
    const numPerCol = Math.ceil(options.length / numCols);
    const numPerInnerCol = Math.ceil(numPerCol / numInnerCols);

    var i = 0;

    return (
      <Row className={className}>
        {range(numCols).map(col => {
          return (
            <Col key={col} sm={colSizeSm} md={colSize}>
              <FormGroup>
                <Row>
                  {range(numInnerCols).map(innerCol => {
                    return (
                      <Col key={innerCol} sm={colInnerSizeSm} md={colInnerSize}>
                        {range(numPerInnerCol).map(() => {
                          const data = options[i];
                          i++;
                          return data ? (
                            <RenderCheckbox
                              {...props}
                              key={i}
                              className={labelClassName}
                              value={data.value !== undefined ? data.value : data}
                              label={data.label || data}
                            />
                          ) : null;
                        })}
                      </Col>
                    );
                  })}
                </Row>
              </FormGroup>
            </Col>
          );
        })}
      </Row>
    );
  }
}

WaterfrontTypeFilter.defaultProps = {
  numCols: 3,
  numInnerCols: 2,
  numColsSm: 2,
  numInnerColsSm: 1,
  type: 'residential'
};

export default WaterfrontTypeFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/waterfront-type-filter.js